import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, LogOut } from "lucide-react";
import { api } from "../lib/api";
import { CategoryRow, download } from "../components/admin/CategoryRow";

export default function AdminDashboard() {
  const [me, setMe] = useState(null);
  const [data, setData] = useState(null);
  const nav = useNavigate();

  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/admin/waitlist/summary");
      setData(d);
    } catch {
      nav("/admin/login", { replace: true });
    }
  }, [nav]);

  useEffect(() => {
    api.get("/auth/me").then(({ data: u }) => { setMe(u); load(); }).catch(() => nav("/admin/login", { replace: true }));
  }, [load, nav]);

  const logout = async () => { await api.post("/auth/logout").catch(() => {}); nav("/admin/login", { replace: true }); };

  if (!me || !data) return <div className="min-h-[90vh] bg-ivory pt-40 text-center text-sm text-graphite" data-testid="admin-loading">Loading…</div>;
  const cats = Array.isArray(data?.categories) ? data.categories : [];

  return (
    <div className="bg-ivory pb-24 pt-32 md:pt-40" data-testid="admin-dashboard">
      <div className="mx-auto max-w-[1300px] px-5 md:px-10">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="label-mono">Admin · {me.email}</p>
            <h1 className="mt-2 font-display text-5xl font-light text-ink md:text-6xl">Waitlists</h1>
          </div>
          <div className="flex gap-2">
            <button onClick={() => download()} className="btn-outline" data-testid="admin-export-all"><Download className="h-4 w-4" />Export all</button>
            <button onClick={logout} className="btn-outline" data-testid="admin-logout"><LogOut className="h-4 w-4" />Sign out</button>
          </div>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
          {[["Total signups", data?.grand_total ?? 0], ["Waiting", cats.reduce((s, c) => s + c.pending, 0)], ["Emailed", cats.reduce((s, c) => s + c.notified, 0)], ["Categories", cats.length]].map(([k, v]) => (
            <div key={k} className="bg-white p-6" data-testid={`admin-stat-${k.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="label-mono">{k}</p>
              <p className="mt-3 font-display text-5xl font-light text-ink">{v}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 overflow-x-auto bg-white px-6" data-lenis-prevent>
          <table className="w-full min-w-[760px] text-left">
            <thead><tr className="border-b border-line font-mono text-[11px] uppercase tracking-[0.2em] text-graphite"><th className="py-4">Category</th><th>Signups</th><th>Status</th><th className="text-right">Actions</th></tr></thead>
            <tbody>{cats.map((c) => <CategoryRow key={c.category} c={c} onDone={load} />)}</tbody>
          </table>
        </div>
        <p className="mt-6 text-xs text-graphite">Launch emails are sent from “MARKHOR” via Emergent's managed email service and only go to people who joined that category's waitlist.</p>
      </div>
    </div>
  );
}
